module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _vm._v(" "), _c('div', [_c('label', [_vm._v("Select Scale")]), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.updateScale
    }
  }, _vm._l((_vm.scales), function(scale) {
    return _c('option', {
      domProps: {
        "value": scale.id
      }
    }, [_vm._v(_vm._s(scale.name))])
  }))]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Key:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.key),
      expression: "key"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.key = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.scaleConfig.possibleNotes), function(note) {
    return _c('option', [_vm._v(_vm._s(note))])
  })), _vm._v(" "), _c('label', [_vm._v("Octave 1")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.octave1),
      expression: "octave1"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.octave1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.scaleConfig.possibleOctaves), function(octave) {
    return _c('option', [_vm._v(_vm._s(octave))])
  })), _vm._v(" "), _c('label', [_vm._v("Octave 2")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.octave2),
      expression: "octave2"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.octave2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.scaleConfig.possibleOctaves), function(octave) {
    return _c('option', [_vm._v(_vm._s(octave))])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "triggerContainer"
    }
  }, _vm._l((_vm.active_scale), function(pitch, index) {
    return _c('synth-trigger', {
      key: index,
      attrs: {
        "config": pitch,
        "playing": _vm.playing[index]
      }
    })
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("scale")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bfc60aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/scale_config.vue
// module id = 273
// module chunks = 1